import extend from 'extend'
import axios from 'axios'
import qs from 'qs'
import store from 'store'
import { invalidSession, encodePath } from 'js/util/util.js'
import jsonpAdapter from 'js/lib/axios-jsonp'

const { CancelToken } = axios
const netApi = axios.create({
  baseURL: '',
  withCredentials: true,
})
const resInter = netApi.interceptors.response.use(
  (res) => {
    if (res.data && res.data.state === 401 && res.data.type === 'error') {
      invalidSession()
    } else {
      return res
    }
  },
  (error) => {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        return invalidSession()
      }
      store.commit('SET_REQUEST_STATUS', `${status}_${new Date().getTime()}`)
    }
    return Promise.reject(error)
  },
)

const VERSION = '/v2'
const URL = {
  getSecretSwitch: '/security/switch/get',
  getClientSetting: '/config/get', // 客户端双击本地打开
  copy: '/fileops/batch_copy', // 摆渡接收详情转存
  ferryInit: '/exchange/task', // 获取摆渡任务信息
  resetFerryTask: '/exchange/task/send_retry', // 重新发起摆渡任务
  getIdentifyImg: '/getcaptcha', // 获取验证码图片
  getPublicKey: '/system/get_publickey', // 获取公钥
  getLenData: '/user/initInfo',
  getUserInfo: '/user/info/get',
  getAccountInfo: '/account/info/get',
  getCustomizeInfo: '/account/funs/get',
  getCustomizeLogo: '/account/logo/get',
  getAuthInfo: '/account/auth_info/get',
  downloadFilePackage: '/packer_router/databox',
  approveInit: '/approve/view_approving_page', // 审批初始化
  queryApprovalTaskInfo: '/approve/get_task_info', // 获取我的审批弹窗信息
  getUserRole: '/manage/user/role', // 获取用户角色
  getCname: '/account/cname/get', // 获取一级域名
  getSession: '/account/getsess', // 获取所有的Session
  getQuota: '/account/quota/get', // 整个企业的用户和空间使用情况
  getAuth: '/delivery/auth_upload', // 外链上传权限校验
  qryUpgradePreview: '/preview/qry_upgrade', // 判断是否是新预览
  newPreviewUrl: '/preview/router', // 新预览方式的获取地址
  newDeliveryPreviewUrl: '/delivery/preview/router', // 外链预览的接口
  oldPreviewUrl: '/web/preview', // 旧预览接口返回的url
  revisions: '/revisions_for_page/databox', // 获取历史版本的接口
  restore: '/restore/databox', // 设置当前版本
  previewFileList: '/previewdata/databox', // 文件列表接口
  previewFileLimit: '/metadata/preview/limit', // 文件是否超限
  deliveryAvStat: '/delivery_av_stat',
  fileDynamics: '/fileDynamics/statistics', // 右侧文件详情获取
  fileDynamicsDetail: '/fileDynamics/detail', // 文件详情类型查询
  updateRevisions: '/revisions/update', // 更新版本说明
  sendRecent: '/recent/create', // 最近访问上报
  checnSmartshare: '/smartshare/check', // 是否为smartshare
  getSmCaptcha: '/smartshare/getcaptcha', // 获取smartshare的验证码
  smartshareFeedback: '/smart/feedback', // 获取smartshare的验证码

  // 新增文件列表接口部分
  extraMeta: '/extra_metadata', // 列表标签
  checkSmCaptcha: '/smartshare/receiversettingcheck', // 验证sm的验证码
  checkDeliveryAuth: '/delivery/auth', // 检查外链的提取码是否正确
  getMetadata: '/metadata_page/databox', // 获取文件列表相关接口
  getSnapShotMetadata: '/metadata/databox',
  usualSearch: '/search_fulltext/databox', // 搜索接口
  smReply: '/smartshare/sendmailtocreater', // smartshare的发送回复接口

  // 转存接口
  deliveryTransfer: '/delivery/delivery_transfor', // 转存接口
  createFolder: '/fileops/create_folder/databox', // 新建文件夹接口
  getDcList: '/dc/clouddc/getDcList', // 获取数据中心列表
  // countdown: '/gl/std/countdown', // 品牌升级预热倒计时
  getOdc: '/odc/user/managed', // 获取用户是否被离线文档管控的接口
  asyncQuery: '/async/query', // 获取异步操作进度
  // 创建分享部分
  getDeliveryRule: '/deliverymanagementsetting/rule/detail', // 获取链接安全管控的规则
  deliveryCreate: '/delivery/create/databox', // 创建外链
  getLinkStatus: '/delivery/status', // 外链相关接口
  linkHistory: '/delivery/history', // 历史链接
  createLinkPrecondition: '/delivery/get_create_precondition', // 创建外链前置条件
  getWaterMark: '/system/getWaterMark', // 服务器水印服务是否开启以及水印内容接口
  WaterMarkForce: '/config/get', // 水印是否强制打开
  createLink: '/delivery/create/databox', // 创建外链
  updateLink: '/delivery/update', // 更新外链
  sendLink: '/delivery/mail/share', // 链接邮件发送
  userTeamSearch: '/user_team/search', // 搜索用户,团队
  get_delivery_info: '/delivery/info', // 获取外链信息
  getSecureDeliveryInfo: '/delivery/security_info', // 获取安全外链信息
  smartshareLisHistoryVisitNum: '/smart/list/deliverylist', // 历史链接中smartshare的访问人数数据
  deleteLink: '/delivery/batch_delete', // 删除链接
  checkFile: '/delivery/fileNum', // 下载校验文件数量大小权限
  downloadLimit: '/delivery/get_remain_download_count', // 下载次数限制校验
  // 评论相关
  createComment: '/comment/create_comment', // 创建新评论
  getComment: '/comment/get_comment', // 获取评论列表
  getCommentAuthList: '/comment/get_auth_list', // 获取@的时候人员列表
  commitSave: '/info_set/databox', // 备注保存
  deleteComment: '/comment/delete_comment', // 删除评论

  // 新功能引导
  featureGuide: '/user/guide_module', // 新用户引导
  getFeatureGuide: '/user/getBubble', // 获取引导信息气泡
  setFeatureGuide: '/user/setBubble', // 设置信息气泡
  batchLogging: '/log/batch_logging', // 批量日志
  log: '/log/logging', // 单个日志
  isExistPolicy: '/approve/is_exist_policy', // 查询审批规则
  isThirdParty: '/approve/get_third_approve_enable', // 查询开启第三方
  apprDownload: '/approve/create_download_task', // 下载审批
  isApproval: '/approve/is_approval', // 判断审批规则是否一致
  docsLock: '/docsLock/databox', // 查询文件锁定状态
  getPolicyApprover: '/approve/get_policy_approver', // 审批者名单
  logout: '/user/logout', // 用户登出
  fileExists: '/fileops/fileExists', // 轻量查询，用于确定文件是否删除
  webAccess: '/account/security/restrict/web/status', // 是否有权限访问web端
  clientAccess: '/account/client_download/get',
  createFileRefShortUrl: '/file_ref/create/short_url', // 获取引用地址的短链
  isEnableOperate: '/security/file/is_enable_operate', // 是否允许操作文件
  clientDownload: '/account/client_download/get', // 获取客户端下载信息
  // 解压缩相关
  isPkg: '/pkg/is_zip', // 判断文件是否为压缩包
  PkgMeta: '/pkg/task/create/meta', // 校验用户预览权限、压缩包大小上限2G、获取压缩包信息
  pkgPreview: '/pkg/task/create/preview',
  pkgDownload: '/pkg/task/create/dl',
}
export default {
  formatUrl(url) {
    return `${VERSION}${url}`
  },
  /**
     * 获取前缀
     */
  getPrefix() {
    return VERSION
  },
  removeResInter() {
    netApi.interceptors.response.eject(resInter)
  },
  getData(url, params, options) {
    let u; let
      opt = null
    const DEFAULT = {
      account_id: store.getters.accountId,
      uid: store.getters.uId,
      S: store.getters.S,
      _: Date.parse(new Date()),
    }
    // 路径可能并不是以当前域名开头，如果不是，以传入的参数为准
    const vu = URL[url] ? VERSION + URL[url] : url
    if (params == null) {
      u = vu
      params = DEFAULT
    } else {
      u = params.url ? VERSION + URL[url] + encodePath(params.url) : vu

      if (params.url) delete params.url
      params = { ...params, ...DEFAULT }
    }
    opt = extend(true, {}, options, { params })
    return netApi.get(u, opt)
  },
  // 可以终止的get请求
  getDataAbort(url, params, options) {
    const cancelToken = axios.CancelToken
    const source = cancelToken.source()
    let u; let
      opt = null
    const DEFAULT = {
      account_id: store.getters.accountId,
      uid: store.getters.uId,
      S: store.getters.S,
      _: Date.parse(new Date()),
    }
    // 路径可能并不是以当前域名开头，如果不是，以传入的参数为准
    const vu = URL[url] ? VERSION + URL[url] : url
    if (params == null) {
      u = vu
      params = DEFAULT
    } else {
      u = params.url ? VERSION + URL[url] + encodePath(params.url) : vu

      if (params.url) delete params.url
      params = { ...params, ...DEFAULT }
    }
    opt = extend(true, {}, options, { params })
    opt.cancelToken = source.token
    const action = axios.get(u, opt)
    return { source, action }
  },

  getUrl(url) {
    return netApi.get(url)
  },

  postData(url, data, options) {
    let u = ''
    const DEFAULT = {
      account_id: store.getters.accountId,
      uid: store.getters.uId,
      S: store.getters.S,
      _: Date.parse(new Date()),
    }
    if (data) {
      if (data.arrayFormat) {
        delete data.arrayFormat
        data = qs.stringify(data, { arrayFormat: 'brackets' })
      } else if (data.repeat) {
        delete data.repeat
        data = qs.stringify(data, { arrayFormat: 'repeat' })
      } else {
        data = qs.stringify(data)
      }
    }

    // 路径可能并不是以当前域名开头，如果不是，以传入的参数为准
    const vu = URL[url] ? VERSION + URL[url] : url
    if (options == null) {
      u = vu
      options = DEFAULT
    } else {
      if (options.url) {
        u = VERSION + URL[url] + encodePath(options.url)

        delete options.url
      } else {
        u = vu
      }
      options = { ...options, ...DEFAULT }
    }
    return netApi.post(u, data, { params: options })
  },

  /**
     * 用 DataFrom 格式 post 数据
     * @param url
     * @param data 对象格式 {key: value}
     * @param options 配置
     * @returns {*}
     */
  postDataByDataForm(url, data, options) {
    const opt = extend(true, {}, options)
    return netApi.post(VERSION + URL[url], qs.stringify(data), opt)
  },

  jsonp(url, cbName = 'cb', callback) {
    axios({
      url,
      adapter: jsonpAdapter,
      callbackName: cbName,
    }).then((res) => {
      callback && callback(res)
    })
  },
  /**
     * jsonp
     * @param 请求对象
     * @param 回调函数名称
     */
  bJsonp(obj, cb) {
    // 写入url地址中的函数名称，动态创建
    const callbackName = cb
    // 创建一个script标签
    const scriptObj = document.createElement('script')
    obj.parames = obj.parames || ''
    if (typeof obj.parames === 'object') {
      const arr = new Array()
      for (const key in obj.parames) {
        arr.push(`${key}=${obj.parames[key]}`)
      }
      if (arr.length > 0) {
        obj.parames = `&${arr.join('&')}`
      } else {
        obj.parames = ''
      }
    }
    // 设置标签的请求路径
    // 像这样：http://localhost:3000/api?callback=jsonp_callback_153498520409635392&id=1
    scriptObj.src = `${obj.url}&callback=${callbackName}${obj.parames}&_=${new Date().getTime()}`
    // 将创建好的带请求的script标签添加到html的body中
    document.body.appendChild(scriptObj)

    // 这里必须这样写window[callbackName];
    // 如果写window.callbackName会报错没有定义
    window[callbackName] = function (res) {
      obj.success(res)
      // 删除的时候可以这样写
      // 由于请求一次会创建一个script标签和一个函数，所以每次获取到结果后就删除
      delete window.callbackName
      document.body.removeChild(scriptObj)
    }
  },
  /**
     * 外链文件夹内使用，与网盘不同
     */
  // upload(url, formdata, progress) {
  //   const cancelToken = axios.CancelToken
  //   const source = cancelToken.source()
  //
  //   const action = axios({
  //     method: 'post',
  //     url,
  //     data: formdata,
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //     transformRequest: [function (data) {
  //       return data
  //     }],
  //     onUploadProgress: progress,
  //     withCredentials: false, // 上传携带Cookies会跨域
  //     cancelToken: source.token,
  //   })
  //   return { source, action } // 取消操作时需要调用cancel()方法
  // },
  // 文件上传接口
  upload(host, urlTail, formdata, progress) {
    const cancelToken = axios.CancelToken
    const source = cancelToken.source()

    const action = axios({
      method: 'post',
      url: `${host}/v2/delivery/data${urlTail}`,
      data: formdata,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      transformRequest: [function (data) {
        return data
      }],
      onUploadProgress: progress,
      withCredentials: false, // 上传携带Cookies会跨域
      cancelToken: source.token,
    })
    return { source, action } // 取消操作时需要调用cancel()方法
  },
}
